import { render, staticRenderFns } from "./ShippingMethodSelect.vue?vue&type=template&id=85bc792c&"
import script from "./ShippingMethodSelect.vue?vue&type=script&lang=ts&"
export * from "./ShippingMethodSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports